<!-- 403 Forbidden页面 -->
<template>
    <div class="admin-error">
        <el-row class="admin-error-content">
            <el-col :span="14">
                <svg class="error-img">
                    <use xlink:href="#403"></use>
                </svg>
            </el-col>
            <el-col :span="10">
                <h5 class="error-code">403</h5>
                <p class="error-message">抱歉，您没有权限访问该页面</p>
                <div>
                    <el-button type="primary" @click="executeLogoutAndGoToLogin()">重新登录</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { defaultApiErrorHandler, PLATFORM_API, LOGOUT_API_URL } from '@/api.js';
import { ADMIN_LOGIN_URL } from '@/constants.js';
import '@/assets/svg/403.svg';
import './error.scss';

export default {
    name: 'Forbidden',

    data() {
        return {};
    },

    methods: {
        executeLogoutAndGoToLogin() {
            this.$http
                .post(PLATFORM_API.of(LOGOUT_API_URL))
                .then(response => {
                    let result = response.data;
                    if (result.success) {
                        this.resetStore(); //reset vuex store
                        window.location.href = ADMIN_LOGIN_URL;
                    } else {
                        this.$message.error(result.message);
                    }
                })
                .catch(defaultApiErrorHandler)
                .then(() => {
                    this.submiting = false;
                });
        },
        resetStore() {
            this.$store.dispatch('resetStore4Logout');
        }
    }
};
</script>
<style lang='scss'>
</style>